<template>
  <div class="list">
    <div
      v-for="(item, index) in items"
      :key="`${index}-${item.label}`"
      :title="item.label"
      :class="getItemClassName(item)"
      @click="() => action(item)"
    >
      <div class="list-description-text">
        <p class="list-text-label">{{ item.label }}</p>
        <p v-if="item.description" class="list-text-description">
          {{ item.description }}
        </p>
      </div>
      <p v-if="item.text" class="list-icon-text">{{ item.text }}</p>
      <div v-if="item.icon" class="list-icon">
        <CustomIcon :name="item.icon" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from "./CustomIcon.vue";
import classnames from "classnames";
export default {
  name: "list-component",
  props: {
    action: {
      type: Function,
    },
    items: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  components: { CustomIcon },
  methods: {
    getItemClassName(item) {
      const className = "list-item";

      return classnames(className, {
        [this.type]: this.type,
        ["is-active"]: item.isActive,
      });
    },
  },
};
</script>
